__webpack_require__.p = "/palladio/flipbook/";